import { LuCheck } from "react-icons/lu";

export type Step = { key: string; label: string; done: boolean; at: string | null };

const day = (iso: string | null) =>
  iso ? new Date(iso).toLocaleDateString(undefined, { day: "numeric", month: "short", year: "numeric" }) : null;

/**
 * Sign-up journey: Opt-in -> Phone -> Email -> Code -> Paid -> Elite.
 * Same stages and colours as the stage tags on the Users page.
 */
const COLORS = ["#EF4444", "#EAB308", "#F97316", "#22C55E", "#7600BC", "#3B82F6"];

const ProfileStepper = ({ steps, current }: { steps: Step[]; current: number }) => (
  <ol className="flex min-w-[640px] items-start" aria-label="Member journey">
    {steps.map((s, i) => {
      const color = COLORS[i] ?? "#7600BC";
      const isCurrent = i === current;
      return (
        <li key={s.key} className="relative flex flex-1 flex-col items-center text-center" aria-current={isCurrent ? "step" : undefined}>
          {i > 0 && (
            <span
              aria-hidden
              className="absolute right-1/2 top-4 h-0.5 w-full -translate-y-1/2"
              style={{ background: steps[i].done ? COLORS[i - 1] : "#E5E7EB" }}
            />
          )}
          <span
            className={`relative z-[1] flex h-8 w-8 items-center justify-center rounded-full border-2 text-xs font-semibold ${
              isCurrent ? "ring-4 ring-offset-0" : ""
            }`}
            style={
              s.done
                ? { background: color, borderColor: color, color: "#fff", ["--tw-ring-color" as string]: `${color}33` }
                : { background: "#fff", borderColor: "#E5E7EB", color: "#9CA3AF" }
            }
          >
            {s.done ? <LuCheck className="h-4 w-4" aria-hidden /> : i + 1}
          </span>
          <span className={`mt-2 text-xs font-medium ${s.done ? "text-honeConnectBlack" : "text-hcMuted"}`}>{s.label}</span>
          <span className="mt-0.5 h-4 text-[11px] text-hcMuted">{s.done ? day(s.at) ?? "" : "Not yet"}</span>
          {isCurrent && <span className="mt-1 rounded-full bg-hcBg px-2 py-0.5 text-[10px] font-semibold uppercase tracking-wide text-honeConnectGray">Current</span>}
        </li>
      );
    })}
  </ol>
);

export default ProfileStepper;
